import { render, staticRenderFns } from "./contentCourseLectureBook.vue?vue&type=template&id=7c6f0454&"
import script from "./contentCourseLectureBook.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports